import { useTranslate } from 'react-translate.ts';
import { AppState } from '../../reducers/root.reducer';
import { AuthActions } from '../../actions';
import { useDispatch, useSelector } from 'react-redux';
import { TRANSLATIONS_ROOT_KEY } from '../../constants/translation.constants';
import styles from './Navbar.module.scss';

type SignOutButtonProps = {
    onClick?: () => void;
};

export default function SignOutButton(props: SignOutButtonProps) {
    const { onClick } = props;
    const isLoggedIn = useSelector(
        (state: AppState) => state.auth.user.isLoggedIn,
    );
    const dispatch = useDispatch();
    const translate = useTranslate(TRANSLATIONS_ROOT_KEY);

    if (!isLoggedIn) {
        return null;
    }

    return (
        <div
            onClick={handleClick}
            className={styles.item__menu__item}
            data-test="sign-out-button"
        >
            {translate('nav.user.logout')}
        </div>
    );

    function logout() {
        dispatch(AuthActions.logout());
    }

    function handleClick() {
        onClick?.();

        logout();
    }
}
